import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeGridModule } from 'se-fe-grid'
import { SeFeLabelValuePairSkeletonComponent } from 'se-fe-label-value-pair/skeleton'

@Component({
  selector: 'se-po-admin-permissions-skeleton',
  standalone: true,
  imports: [SeFeCardModule, SeFeCardHeaderSkeletonComponent, SeFeGridModule, SeFeLabelValuePairSkeletonComponent],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton
        [seFeDataAction]="true"
        [seFeDataHeavyBorder]="true"
        [seFeDataTitle]="true">
        seFeDataSubtitle="text|long">
      </se-fe-card-header-skeleton>
      <se-fe-card-content>
        <se-fe-grid seFeGridOpts>
          <se-fe-grid-cell seFeGridOpts="1/2">
            <se-fe-label-value-pair-skeleton seFeDataValue="text|long|6"></se-fe-label-value-pair-skeleton>
          </se-fe-grid-cell>
          <se-fe-grid-cell seFeGridOpts="1/2">
            <se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton>
          </se-fe-grid-cell>
        </se-fe-grid>
      </se-fe-card-content>
    </se-fe-card>
  `,
})
export class AdminPermissionsSkeletonComponent {}
